
import { defineComponent, computed } from 'vue'
import { WeveButtonIcon } from '@weve/ui'

import { ROOM_ROUTES_NAMES } from '@/router/router.constants'
import { useRoute, useLastRoom } from '@/use'
import { CloseIcon } from '@icons'

export default defineComponent({
  name: 'LastRoom',
  components: {
    WeveButtonIcon,
    CloseIcon,
  },
  setup() {
    const { active, lastRoom, discard } = useLastRoom()

    const route = useRoute()

    const visible = computed(
      () =>
        active.value &&
        ROOM_ROUTES_NAMES.has(route.value.name ?? '') === false &&
        lastRoom.value !== null
    )

    return {
      visible,
      lastRoom,
      discard,
    }
  },
})
